import { marked } from 'marked';

// Shared renderer instance (module singleton) so we don't allocate one per message.
export const chatMessageMarkedRenderer = (() => {
  const renderer = new marked.Renderer();

  const escapeAttr = (value) =>
    String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

  renderer.link = function (...args) {
    // marked v16 passes a single "token" object; older versions pass (href, title, text).
    const token = typeof args[0] === 'object' && args[0] !== null ? args[0] : null;
    const href = token ? token.href : args[0];
    const title = token ? token.title : args[1];
    const text =
      token && token.text != null
        ? token.text
        : token && token.tokens && this?.parser?.parseInline
          ? this.parser.parseInline(token.tokens)
          : args[2] ?? '';

    const titleAttr = title ? ` title="${escapeAttr(title)}"` : '';
    return `<a href="${escapeAttr(href)}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
  };

  return renderer;
})();

